import React, {useEffect, useState} from 'react';
import {
    Accordion, AccordionBody,
    AccordionHeader,
    Button,
    Card,
    CardBody, Dialog, DialogBody, DialogFooter, DialogHeader,
    Input, Option, Radio, Select,
    Textarea,
    Typography
} from "@material-tailwind/react";
import MapComponent from "../../shared/map_component";
import InputMask from "react-input-mask";
import RoadSelect from "../../shared/road_select";
import NeighborhoodSelect from "../../shared/neighborhood_select";
import {NumericFormat} from "react-number-format";
import {CheckIcon} from "@heroicons/react/16/solid";
import MapComponentSearch from "../../shared/map_component_search";
import {ChevronDownIcon, ChevronRightIcon} from "@heroicons/react/24/solid";
import axios from "axios";

const Fusion = ({lot, movement}) => {
    const [step, setStep] = useState(1);
    const [searchType, setSearchType] = useState("search_by_cve");
    const [error, setError] = useState(null);
    const [parcelCode, setParcelCode] = useState("");
    const [lots, setLots] = useState([]);
    const [selectedContributor, setSelectedContributor] = useState(null);
    const [lotFusion, setLotFusion] = useState(null)
    const [contributors, setContributors] = useState(null);
    const [name, setName] = useState("");
    const [pLastName, setPLastName] = useState("");
    const [mLastName, setMLastName] = useState("");
    const [lotNotes, setLotNotes] = useState("");
    const [openAccordion, setOpenAccordion] = useState(null);
    const [loaderActive, setLoaderActive] = useState(false);
    const [openEndDialog, setOpenEndDialog] = useState(false);
    const [constructions, setConstructions] = useState([]);
    const [lands, setLands] = useState([]);
    const [constructionsFusion, setConstructionsFusion] = useState([]);
    const [landsFusion, setLandsFusion] = useState([]);
    const [fusionedLands, setFusionedLands] = useState([]);
    const [fusionedConstructions, setFusionedConstructions] = useState([]);

    useEffect(() => {
        async function fetchLotDetails() {
            try {
                const [constructionsResponse, landResponse] = await Promise.all([
                    fetch(`/lots/${lot.parcel_code}/constructions.json`),
                    fetch(`/lots/${lot.parcel_code}/land.json`),
                ]);

                if (constructionsResponse.ok) {
                    const constructionsData = await constructionsResponse.json();
                    setConstructions(constructionsData);
                    setFusionedConstructions(constructionsData);
                } else {
                    console.log("No se encontraron construcciones para este código.");
                }

                if (landResponse.ok) {
                    const landData = await landResponse.json();
                    setLands(landData);
                    setFusionedLands(landData);

                } else {
                    console.log("No se encontraron terrenos para este código.");
                }

            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }
        }

        fetchLotDetails();
        setLotNotes(lot.notes);
    }, [lot]);

    const getCSRFToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : "";
    };


    const handleReset = () => {
        window.location.replace('movements');
    };

    const handleBuscar = async () => {
        setError(null);
        setLots([]);
        setSelectedContributor(null);

        if (searchType === "search_by_cve") {
            if (parcelCode.trim() === "") return setError("Ingrese una clave válida");

            await handleSelectPredio(parcelCode);
        } else if (searchType === "search_by_name") {
            if (name.trim() === "" && pLastName.trim() === "" && mLastName.trim() === "") return alert("Ingrese un nombre válido");

            try {
                const response = await fetch(`/lots/search_by_name?name=${name}&parental_last_name=${pLastName}&maternal_last_name=${mLastName}&reason_type=${movementId}`);

                if (!response.ok) {
                    setError("No se encontraron contribuyentes.");
                    setStep(1);
                    return;
                }

                const data = await response.json();
                setContributors(data);
            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }
        }
    };

    const handleGetLotsByContributor = async (contributorId) => {
        try {
            const response = await fetch(`/lots/search_by_contributor?id=${contributorId}`);
            const data = await response.json();
            setLots(data);
            setSelectedContributor(contributorId);
        } catch (err) {
            console.error("Error fetching lots:", err);
        }
    };

    const handleSelectPredio = async (parcel_code) => {
        setParcelCode(parcel_code);

        try {
            const [lotsResponse, constructionsResponse, landResponse] = await Promise.all([
                fetch(`/lots/${parcel_code}/search_by_code.json`),
                fetch(`/lots/${parcel_code}/constructions.json`),
                fetch(`/lots/${parcel_code}/land.json`),
            ]);

            if (!lotsResponse.ok) {
                setError("No se encontraron datos para este código.");
                setStep(1);
                return;
            } else {

            }
            const lotsData = await lotsResponse.json();
            setLotFusion(lotsData);

            if (constructionsResponse.ok) {
                const constructionsData = await constructionsResponse.json();
                setConstructionsFusion(constructionsData);
                setFusionedConstructions(prev => [...prev, ...constructionsData]);
            } else {
                console.log("No se encontraron construcciones para este código.");
            }

            if (landResponse.ok) {
                const landData = await landResponse.json();
                setLandsFusion(landData);
                setFusionedLands(prev => [...prev, ...landData]);

            } else {
                console.log("No se encontraron terrenos para este código.");
            }

        } catch (err) {
            console.error("Error al buscar el predio:", err);
        }

        setStep(2);
    };

    const handleSubmit = async () => {
        setLoaderActive(true);

        try {
            const response = await axios.post(`lots/${lot.parcel_code}/${lotFusion.parcel_code}/fusion.json`, {
                lot: {
                    notes: lotNotes,
                    reason_type_id: movement.id,
                },
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRF-Token": getCSRFToken(),
                }
            });
            if (response.status === 200) {
                setOpenEndDialog(true);
                const current_lot_url = `/lots/${lot.parcel_code}/print_movement.pdf`;
                window.open(current_lot_url, '_blank');
                setLoaderActive(false);
            } else {
                setError('Error al actualizar el predio. Verifica los datos.');
                setLoaderActive(false);
            }
        } catch (err) {
            setError('Ocurrió un error al fusionar los predios');
            setLoaderActive(false);
        }
    };

    const totalConstArea = constructions.reduce((acc, construction) => acc + (construction.area), 0);
    const totalConstValue = constructions.reduce((acc, construction) => acc + construction.valuation, 0);
    const totalLandArea = lands ? lands.reduce((acc, land) => acc + (land.area), 0) : 0;

    const totalConstAreaFusion = constructionsFusion.reduce((acc, construction) => acc + (construction.area), 0);
    const totalConstValueFusion = constructionsFusion.reduce((acc, construction) => acc + construction.valuation, 0);
    const totalLandAreaFusion = landsFusion ? landsFusion.reduce((acc, land) => acc + (land.area), 0) : 0;

    const resultConstructions = fusionedConstructions.reduce((acc, construction) => acc + (construction.area), 0);
    const resultLands = fusionedLands.reduce((acc, land) => acc + (land.area), 0);

    const getUnit = lot.lot_location_type === 'URBANO' ? <>m<sup>2</sup></> : <>ha</>;

    return (
        <>
            <div className="flex-auto py-6 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Información del predio seleccionado
                </h6>
                <div className="flex flex-col lg:flex-row gap-4 min-h-[350px]">
                    <div
                        className="flex-grow border border-blue-gray-100 p-4 rounded-t-none rounded-b-lg w-full lg:w-1/2 overflow-x-hidden">
                        {lot && (
                            <CardBody className='p-0'>
                                <div className="w-full mb-4 bg-gray-100">
                                    {(lot.latitude && lot.longitude) && (
                                        <MapComponent
                                            parcel_code={lot.parcel_code}
                                            latitude={lot.latitude}
                                            longitude={lot.longitude}
                                        />
                                    )}
                                </div>
                                <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Clave catastral
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.parcel_code}
                                        </Typography>
                                    </div>
                                </div>
                                <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Dirección
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.road_name}{lot.ext_num ? " #" + lot.ext_num : ""}, {lot.neighborhood_name},
                                            C.P. {lot.postal_code}
                                        </Typography>
                                    </div>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Referencias
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.address_references === null ? '' : lot.address_references}
                                        </Typography>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                    REGISTRO DEL PREDIO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    R.P.P.
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Insc.
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.inscription}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Folio
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.folio}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Libro
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.book}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    Fecha efecto
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Bim
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.effective_bimester}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Año
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.effective_year}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    Fecha exento
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex w-full gap-1'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Bim. inicio
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.start_exempt_bimester}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Año inicio
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.start_exempt_year}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                    <div className='flex w-full gap-1'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Bim. fin
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.end_exempt_bimester}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Año fin
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.end_exempt_year}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                    PROPIETARIO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <div className='py-2'>
                                                {lot.contributor_type === 'P' ? (
                                                    <div className='flex flex-row gap-4 w-full text-center'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Nombre
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.name}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Apellido paterno
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.parental_last_name}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Apellido Materno
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.maternal_last_name}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='flex flex-row gap-4 w-full text-center'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Razón social
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.name}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className='flex flex-row gap-4 mt-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Dirección
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.contributor_street}
                                                            {lot.contributor_ext_num ? " #" + lot.contributor_ext_num : ""}
                                                            {lot.contributor_neighborhood ? ', ' + lot.contributor_neighborhood : ''}
                                                            {lot.contributor_postal_code ? ', C.P. ' + lot.contributor_postal_code : ''}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Teléfono
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.phone ? lot.phone : 'N/A'}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            RFC
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.rfc ? lot.rfc : 'N/A'}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                                    TERRENO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <Card className='w-full border-0' shadow={false}>
                                                <CardBody className='p-0'>
                                                    <table className="w-full min-w-[640px] table-auto border">
                                                        <thead>
                                                        <tr className='bg-gray-50'>
                                                            {["Cve. Val.", "Descripción", "Área"].map(
                                                                (el) => (
                                                                    <th
                                                                        key={el}
                                                                        className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                    >
                                                                        <Typography
                                                                            variant="small"
                                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                        >
                                                                            {el}
                                                                        </Typography>
                                                                    </th>
                                                                )
                                                            )}
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {(!lands || lands.length === 0) ? (
                                                            <tr className="w-full">
                                                                <td colSpan="100%" className="text-center py-3">
                                                                    <strong>El predio no cuenta con terrenos
                                                                        registrados.</strong>
                                                                </td>
                                                            </tr>
                                                        ) : (Object.entries(lands).map(([landId, data], index, array) => {
                                                                const className = `py-3 px-5 ${
                                                                    index === array.length - 1 ? "" : "border-b border-blue-gray-50"
                                                                }`;
                                                                return (
                                                                    <tr key={landId}
                                                                        className="hover:bg-gray-50 cursor-pointer">
                                                                        <td className={className}>{data.rustic_land_value_id ? data.rustic_land_value_id : 'N/A'}</td>
                                                                        <td className={className}>{data.rustic_land_desc ? data.rustic_land_desc : 'Terreno urbano'}</td>
                                                                        <td className={className}>
                                                                            <NumericFormat
                                                                                value={data.area}
                                                                                displayType={'text'}
                                                                                allowLeadingZeros
                                                                                thousandSeparator=","
                                                                            /> {getUnit}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        )}
                                                        </tbody>
                                                        <tfoot>
                                                        <tr className='border-t'>
                                                            <td colSpan='2'
                                                                className='py-3 px-5 text-right border-r'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Totales
                                                                </Typography>
                                                            </td>
                                                            <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                                <NumericFormat
                                                                    value={totalLandArea.toFixed(2)}
                                                                    displayType={'text'}
                                                                    allowLeadingZeros
                                                                    thousandSeparator=","
                                                                /> {getUnit}
                                                            </td>
                                                        </tr>
                                                        </tfoot>
                                                    </table>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                                    CONSTRUCCIONES
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <Card className='w-full border-0' shadow={false}>
                                                <CardBody className='p-0'>
                                                    <table className="w-full min-w-[640px] table-auto">
                                                        <thead>
                                                        <tr className='bg-gray-50'>
                                                            {["Cve. Valuación", "Edad", "Sup. Construcción", "Valor"].map(
                                                                (el) => (
                                                                    <th
                                                                        key={el}
                                                                        className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                    >
                                                                        <Typography
                                                                            variant="small"
                                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                        >
                                                                            {el}
                                                                        </Typography>
                                                                    </th>
                                                                )
                                                            )}
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {(!constructions || constructions.length === 0) ? (
                                                            <tr className="w-full">
                                                                <td colSpan="100%" className="text-center py-3">
                                                                    <strong>El predio no cuenta con
                                                                        construcciones.</strong>
                                                                </td>
                                                            </tr>
                                                        ) : (constructions.map((construction, index) => {
                                                                const className = `py-3 px-5 ${
                                                                    index === constructions.length - 1 ? "" : "border-b border-blue-gray-50"
                                                                }`;
                                                                return (
                                                                    <tr key={construction.construction_id}
                                                                        className="hover:bg-gray-50 cursor-pointer">
                                                                        <td className={className}>
                                                                            {construction.construction_value_id}
                                                                        </td>
                                                                        <td className={className}>
                                                                            {construction.construction_devaluation_id.toString()}
                                                                        </td>
                                                                        <td className={className}>
                                                                            {construction.area}
                                                                            <span
                                                                                className='py-2'>m<sup>2</sup></span>
                                                                        </td>
                                                                        <td className={className}>
                                                                            <NumericFormat
                                                                                value={construction.value.toFixed(2)}
                                                                                displayType={'text'}
                                                                                prefix={'$'}
                                                                                thousandSeparator=","
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        )}

                                                        </tbody>
                                                        <tfoot>
                                                        <tr className='border-t'>
                                                            <td colSpan='2' className='py-3 px-5 text-right border-r'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Totales
                                                                </Typography>
                                                            </td>
                                                            <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                                <NumericFormat
                                                                    value={totalConstArea}
                                                                    displayType={'text'}
                                                                    thousandSeparator=","
                                                                /> m<sup>2</sup>
                                                            </td>
                                                            <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b border-r'>
                                                                <NumericFormat
                                                                    value={totalConstValue.toFixed(2)}
                                                                    displayType={'text'}
                                                                    prefix={'$'}
                                                                    thousandSeparator=","
                                                                />
                                                            </td>
                                                        </tr>
                                                        </tfoot>
                                                    </table>
                                                    <div
                                                        className='flex flex-row gap-4 w-full mt-6 text-center border rounded-md bg-gray-50'>
                                                        <div
                                                            className='flex flex-col w-full p-4 place-content-center'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Instalaciones especiales
                                                            </Typography>
                                                            <div
                                                                className="flex flex-row justify-center gap-1"
                                                            >
                                                                <NumericFormat
                                                                    value={lot.special_facilities_value}
                                                                    displayType={'text'}
                                                                    prefix={'$'}
                                                                    thousandSeparator=","
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            className={`flex flex-col w-full p-4 ${lot.special_facilities && 'border rounded-md bg-gray-50'}`}>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Descripción de instalaciones especiales
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.special_facilities}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex-auto py-6 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Información predio a fusionar (por eliminar)
                </h6>
                <div className="flex flex-col lg:flex-row gap-4">
                    <div
                        className="flex-grow border border-blue-gray-100 p-4 rounded-t-none rounded-b-lg w-full lg:w-1/2 overflow-x-hidden">
                        {step === 1 ? (
                            <>
                                <div className="mb-6">
                                    <div className="flex gap-4 items-center bg-gray-100 p-4 rounded">
                                        <span className="text-lg font-bold whitespace-nowrap pr-4">Búsqueda por:</span>
                                        <Select
                                            value={searchType}
                                            onChange={(e) => setSearchType(e)}
                                            className="w-full"
                                        >
                                            <Option value="search_by_cve">Clave catastral</Option>
                                            <Option value="search_by_name">Nombre y Apellidos</Option>
                                        </Select>
                                    </div>
                                    <div className="mt-4 bg-white p-6 rounded shadow-md">
                                        {searchType === "search_by_cve" && (
                                            <section id="find_by_cve">
                                                <div
                                                    className="flex justify-between md:items-center gap-y-4 flex-col md:flex-row">
                                                    <div>
                                                        <h1 className="font-bold text-lg">BUSQUEDA POR PREDIO</h1>
                                                        <p className="text-sm text-gray-500">
                                                            Ingresa la clave catastral para buscar.
                                                        </p>
                                                        {error && <p style={{color: "red"}}>{error}</p>}
                                                    </div>
                                                    <div className="flex gap-2">
                                                        <div className="lg:w-96">

                                                            <InputMask
                                                                mask="519999-999-999"
                                                                value={parcelCode}
                                                                onChange={(e) => setParcelCode(e.target.value)}
                                                            >
                                                                {(inputProps) => (
                                                                    <input
                                                                        {...inputProps}
                                                                        type="text"
                                                                        placeholder="51XXXX-XXX-XXX"
                                                                        className="p-2 w-full border border-gray-300 rounded"
                                                                    />
                                                                )}
                                                            </InputMask>
                                                        </div>
                                                        <Button onClick={handleBuscar}>Buscar</Button>
                                                    </div>
                                                </div>
                                            </section>
                                        )}
                                        {searchType === "search_by_name" && (
                                            <>
                                                <section id="find_by_name">
                                                    <div
                                                        className="flex justify-between md:items-center gap-y-4 flex-col md:flex-row">
                                                        <div>
                                                            <h1 className="font-bold text-lg">BUSQUEDA POR NOMBRE</h1>
                                                            <p className="text-sm text-gray-500">
                                                                Ingresa los datos del predio para buscar.
                                                            </p>
                                                            {error && <p style={{color: "red"}}>{error}</p>}
                                                        </div>
                                                        <div className="flex flex-wrap gap-2 items-center">
                                                            <input
                                                                type="text"
                                                                placeholder="Nombre"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded uppercase"
                                                                value={name}
                                                                onChange={(e) => setName(e.target.value.toUpperCase())}
                                                            />
                                                            <input
                                                                type="text"
                                                                placeholder="Apellido Paterno"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded uppercase"
                                                                value={pLastName}
                                                                onChange={(e) => setPLastName(e.target.value.toUpperCase())}
                                                            />
                                                            <input
                                                                type="text"
                                                                placeholder="Apellido Materno"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded uppercase"
                                                                value={mLastName}
                                                                onChange={(e) => setMLastName(e.target.value.toUpperCase())}
                                                            />
                                                            <Button onClick={handleBuscar}>Buscar</Button>
                                                        </div>
                                                    </div>
                                                </section>
                                            </>
                                        )}
                                    </div>
                                    {searchType === "search_by_name" && contributors && (
                                        <div className="mt-8">
                                            {contributors.length > 0 ? (
                                                <div>
                                                    <h6 className="font-semibold uppercase text-gray-600 mb-4">
                                                        Resultados de búsqueda
                                                    </h6>

                                                    <ul className="border p-4 rounded-md bg-white shadow">
                                                        {contributors.map((contributor, index) => (
                                                            <li key={contributor.id}
                                                                className={`${index === contributors.length - 1 ? "" : "border-b"}`}>
                                                                <div
                                                                    className="flex justify-between items-center py-3 px-4 rounded-md cursor-pointer hover:bg-blue-gray-50 transition duration-200"
                                                                    onClick={() => handleGetLotsByContributor(contributor.id)}
                                                                >
                                                                    <span className="text-gray-700 font-medium">
                                                                        <strong>
                                                                          {contributor.name} {contributor.parental_last_name} {contributor.maternal_last_name}
                                                                        </strong>
                                                                    </span>
                                                                    {selectedContributor === contributor.id ? (
                                                                        <ChevronDownIcon
                                                                            className="h-5 w-5 text-gray-700"/>
                                                                    ) : (
                                                                        <ChevronRightIcon
                                                                            className="h-5 w-5 text-gray-500"/>
                                                                    )}
                                                                </div>
                                                                {selectedContributor === contributor.id && (
                                                                    <ul className="p-4 mt-2 bg-blue-gray-500/20 rounded-md">
                                                                        {lots.length > 0 ? (
                                                                            lots.map((lot, index) => (
                                                                                <li
                                                                                    key={`${lot.parcel_code}-${index}`}
                                                                                    className={`flex justify-between items-center py-2 px-3 rounded-md cursor-pointer hover:bg-gray-100 transition duration-200 hover:bg-brown-500/10 ${index === lots.length - 1 ? "" : "border-b border-blue-gray-50"}`}
                                                                                    onClick={() => handleSelectPredio(lot.parcel_code)}
                                                                                >
                                                                                  <span className="text-gray-600">
                                                                                    <strong>{lot.parcel_code}</strong>: {`${lot.road_name}${lot.ext_num ? ' #' + lot.ext_num : ''}, ${lot.neighborhood_name}`}
                                                                                  </span>
                                                                                </li>
                                                                            ))
                                                                        ) : (
                                                                            <li className="text-gray-500 italic">No se
                                                                                encontraron <strong>predios.</strong>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                )}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ) : (
                                                <div>
                                                    <h6 className="font-semibold uppercase text-gray-600 my-4 text-center">
                                                        No se encontraron coincidencias.
                                                    </h6>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </>
                        ) : (
                            <>
                                {lotFusion && (
                                    <CardBody className='p-0'>
                                        <div className="w-full mb-4 bg-gray-100">
                                            {(lotFusion.latitude && lotFusion.longitude) && (
                                                <MapComponent
                                                    parcel_code={lotFusion.parcel_code}
                                                    latitude={lotFusion.latitude}
                                                    longitude={lotFusion.longitude}
                                                />
                                            )}
                                        </div>
                                        <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                            <div className='flex flex-col w-full'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                >
                                                    Clave catastral
                                                </Typography>
                                                <Typography
                                                    variant="paragraph"
                                                    className="font-medium"
                                                >
                                                    {lotFusion.parcel_code}
                                                </Typography>
                                            </div>
                                        </div>
                                        <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                            <div className='flex flex-col w-full'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                >
                                                    Dirección
                                                </Typography>
                                                <Typography
                                                    variant="paragraph"
                                                    className="font-medium"
                                                >
                                                    {lotFusion.road_name}{lotFusion.ext_num ? " #" + lotFusion.ext_num : ""}, {lotFusion.neighborhood_name},
                                                    C.P. {lotFusion.postal_code}
                                                </Typography>
                                            </div>
                                            <div className='flex flex-col w-full'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                >
                                                    Referencias
                                                </Typography>
                                                <Typography
                                                    variant="paragraph"
                                                    className="font-medium"
                                                >
                                                    {lotFusion.address_references === null ? '' : lotFusion.address_references}
                                                </Typography>
                                            </div>
                                        </div>
                                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                        <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                            REGISTRO DEL PREDIO
                                        </h6>
                                        <div className="flex flex-wrap">
                                            <div className="w-full lg:w-12/12 px-0">
                                                <div className="relative w-full mb-3">
                                                    <div className='py-2'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                        >
                                                            R.P.P.
                                                        </Typography>
                                                        <div className='flex flex-row gap-4 w-full text-center'>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Insc.
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    {lotFusion.inscription}
                                                                </Typography>
                                                            </div>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Folio
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    {lotFusion.folio}
                                                                </Typography>
                                                            </div>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Libro
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    {lotFusion.book}
                                                                </Typography>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='py-2'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                        >
                                                            Fecha efecto
                                                        </Typography>
                                                        <div className='flex flex-row gap-4 w-full text-center'>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Bim
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    {lotFusion.effective_bimester}
                                                                </Typography>
                                                            </div>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Año
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    {lotFusion.effective_year}
                                                                </Typography>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='py-2'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                        >
                                                            Fecha exento
                                                        </Typography>
                                                        <div className='flex flex-row gap-4 w-full text-center'>
                                                            <div className='flex w-full gap-1'>
                                                                <div className='flex flex-col w-full'>
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        Bim. inicio
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="paragraph"
                                                                        className="font-medium"
                                                                    >
                                                                        {lotFusion.start_exempt_bimester}
                                                                    </Typography>
                                                                </div>
                                                                <div className='flex flex-col w-full'>
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        Año inicio
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="paragraph"
                                                                        className="font-medium"
                                                                    >
                                                                        {lotFusion.start_exempt_year}
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                            <div className='flex w-full gap-1'>
                                                                <div className='flex flex-col w-full'>
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        Bim. fin
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="paragraph"
                                                                        className="font-medium"
                                                                    >
                                                                        {lotFusion.end_exempt_bimester}
                                                                    </Typography>
                                                                </div>
                                                                <div className='flex flex-col w-full'>
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        Año fin
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="paragraph"
                                                                        className="font-medium"
                                                                    >
                                                                        {lotFusion.end_exempt_year}
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                        <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                            PROPIETARIO
                                        </h6>
                                        <div className="flex flex-wrap">
                                            <div className="w-full lg:w-12/12 px-0">
                                                <div className="relative w-full mb-3">
                                                    <div className='py-2'>
                                                        {lotFusion.contributor_type === 'P' ? (
                                                            <div className='flex flex-row gap-4 w-full text-center'>
                                                                <div className='flex flex-col w-full'>
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        Nombre
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="paragraph"
                                                                        className="font-medium"
                                                                    >
                                                                        {lotFusion.name}
                                                                    </Typography>
                                                                </div>
                                                                <div className='flex flex-col w-full'>
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        Apellido paterno
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="paragraph"
                                                                        className="font-medium"
                                                                    >
                                                                        {lotFusion.parental_last_name}
                                                                    </Typography>
                                                                </div>
                                                                <div className='flex flex-col w-full'>
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        Apellido Materno
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="paragraph"
                                                                        className="font-medium"
                                                                    >
                                                                        {lotFusion.maternal_last_name}
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className='flex flex-row gap-4 w-full text-center'>
                                                                <div className='flex flex-col w-full'>
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        Razón social
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="paragraph"
                                                                        className="font-medium"
                                                                    >
                                                                        {lotFusion.name}
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div
                                                            className='flex flex-row gap-4 mt-4 w-full text-center'>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Dirección
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    {lotFusion.contributor_street}
                                                                    {lotFusion.contributor_ext_num ? " #" + lotFusion.contributor_ext_num : ""}
                                                                    {lotFusion.contributor_neighborhood ? ', ' + lotFusion.contributor_neighborhood : ''}
                                                                    {lotFusion.contributor_postal_code ? ', C.P. ' + lotFusion.contributor_postal_code : ''}
                                                                </Typography>
                                                            </div>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Teléfono
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    {lotFusion.phone ? lotFusion.phone : 'N/A'}
                                                                </Typography>
                                                            </div>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    RFC
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    {lotFusion.rfc ? lotFusion.rfc : 'N/A'}
                                                                </Typography>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                        <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                                            TERRENO
                                        </h6>
                                        <div className="flex flex-wrap">
                                            <div className="w-full lg:w-12/12 px-0">
                                                <div className="relative w-full mb-3">
                                                    <Card className='w-full border-0' shadow={false}>
                                                        <CardBody className='p-0'>
                                                            <table
                                                                className="w-full min-w-[640px] table-auto border">
                                                                <thead>
                                                                <tr className='bg-gray-50'>
                                                                    {["Cve. Val.", "Descripción", "Área"].map(
                                                                        (el) => (
                                                                            <th
                                                                                key={el}
                                                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                            >
                                                                                <Typography
                                                                                    variant="small"
                                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                                >
                                                                                    {el}
                                                                                </Typography>
                                                                            </th>
                                                                        )
                                                                    )}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {(!Object.entries(landsFusion) || Object.entries(landsFusion).length === 0) ? (
                                                                    <tr className="w-full">
                                                                        <td colSpan="100%"
                                                                            className="text-center py-3">
                                                                            <strong>El predio no cuenta con terrenos
                                                                                registrados.</strong>
                                                                        </td>
                                                                    </tr>
                                                                ) : (Object.entries(landsFusion).map(([landId, data], index, array) => {
                                                                        const className = `py-3 px-5 ${
                                                                            index === array.length - 1 ? "" : "border-b border-blue-gray-50"
                                                                        }`;
                                                                        return (
                                                                            <tr key={landId}
                                                                                className="hover:bg-gray-50 cursor-pointer">
                                                                                <td className={className}>{data.rustic_land_value_id ? data.rustic_land_value_id : 'N/A'}</td>
                                                                                <td className={className}>{data.rustic_land_desc ? data.rustic_land_desc : 'Terreno urbano'}</td>
                                                                                <td className={className}>
                                                                                    <NumericFormat
                                                                                        value={data.area}
                                                                                        displayType={'text'}
                                                                                        allowLeadingZeros
                                                                                        thousandSeparator=","
                                                                                    /> {getUnit}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                )}
                                                                </tbody>
                                                                <tfoot>
                                                                <tr className='border-t'>
                                                                    <td colSpan='2'
                                                                        className='py-3 px-5 text-right border-r'>
                                                                        <Typography
                                                                            variant="small"
                                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                        >
                                                                            Totales
                                                                        </Typography>
                                                                    </td>
                                                                    <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                                        <NumericFormat
                                                                            value={totalLandAreaFusion.toFixed(2)}
                                                                            displayType={'text'}
                                                                            allowLeadingZeros
                                                                            thousandSeparator=","
                                                                        /> {getUnit}
                                                                    </td>
                                                                </tr>
                                                                </tfoot>
                                                            </table>
                                                        </CardBody>
                                                    </Card>
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                        <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                                            CONSTRUCCIONES
                                        </h6>
                                        <div className="flex flex-wrap">
                                            <div className="w-full lg:w-12/12 px-0">
                                                <div className="relative w-full mb-3">
                                                    <Card className='w-full border-0' shadow={false}>
                                                        <CardBody className='p-0'>
                                                            <table className="w-full min-w-[640px] table-auto">
                                                                <thead>
                                                                <tr className='bg-gray-50'>
                                                                    {["Cve. Valuación", "Edad", "Sup. Construcción", "Valor"].map(
                                                                        (el) => (
                                                                            <th
                                                                                key={el}
                                                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                            >
                                                                                <Typography
                                                                                    variant="small"
                                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                                >
                                                                                    {el}
                                                                                </Typography>
                                                                            </th>
                                                                        )
                                                                    )}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {(!constructionsFusion || constructionsFusion.length === 0) ? (
                                                                    <tr className="w-full">
                                                                        <td colSpan="100%"
                                                                            className="text-center py-3">
                                                                            <strong>El predio no cuenta con
                                                                                construcciones.</strong>
                                                                        </td>
                                                                    </tr>
                                                                ) : (constructionsFusion.map((construction, index) => {
                                                                        const className = `py-3 px-5 ${
                                                                            index === constructions.length - 1 ? "" : "border-b border-blue-gray-50"
                                                                        }`;
                                                                        return (
                                                                            <tr key={construction.construction_id}
                                                                                className="hover:bg-gray-50 cursor-pointer">
                                                                                <td className={className}>
                                                                                    {construction.construction_value_id}
                                                                                </td>
                                                                                <td className={className}>
                                                                                    {construction.construction_devaluation_id.toString()}
                                                                                </td>
                                                                                <td className={className}>
                                                                                    {construction.area}
                                                                                    <span
                                                                                        className='py-2'>m<sup>2</sup></span>
                                                                                </td>
                                                                                <td className={className}>
                                                                                    <NumericFormat
                                                                                        value={construction.value.toFixed(2)}
                                                                                        displayType={'text'}
                                                                                        prefix={'$'}
                                                                                        thousandSeparator=","
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                )}

                                                                </tbody>
                                                                <tfoot>
                                                                <tr className='border-t'>
                                                                    <td colSpan='2'
                                                                        className='py-3 px-5 text-right border-r'>
                                                                        <Typography
                                                                            variant="small"
                                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                        >
                                                                            Totales
                                                                        </Typography>
                                                                    </td>
                                                                    <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                                        <NumericFormat
                                                                            value={totalConstAreaFusion}
                                                                            displayType={'text'}
                                                                            thousandSeparator=","
                                                                        /> m<sup>2</sup>
                                                                    </td>
                                                                    <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b border-r'>
                                                                        <NumericFormat
                                                                            value={totalConstValueFusion.toFixed(2)}
                                                                            displayType={'text'}
                                                                            prefix={'$'}
                                                                            thousandSeparator=","
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                </tfoot>
                                                            </table>
                                                            <div
                                                                className='flex flex-row gap-4 w-full mt-6 text-center border rounded-md bg-gray-50'>
                                                                <div
                                                                    className='flex flex-col w-full p-4 place-content-center'>
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        Instalaciones especiales
                                                                    </Typography>
                                                                    <div
                                                                        className="flex flex-row justify-center gap-1"
                                                                    >
                                                                        <NumericFormat
                                                                            value={lotFusion.special_facilities_value}
                                                                            displayType={'text'}
                                                                            prefix={'$'}
                                                                            thousandSeparator=","
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={`flex flex-col w-full p-4 ${lot.special_facilities && 'border rounded-md bg-gray-50'}`}>
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        Descripción de instalaciones especiales
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="paragraph"
                                                                        className="font-medium"
                                                                    >
                                                                        {lotFusion.special_facilities}
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        </CardBody>
                                                    </Card>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
            {lotFusion && (
                <div className="flex-auto py-6 pt-0">
                    <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                        Resultado de la fusión
                    </h6>
                    <div className="flex flex-col lg:flex-row gap-4 min-h-[350px]">
                        <div
                            className="flex-grow border border-blue-gray-100 p-4 rounded-t-none rounded-b-lg w-full lg:w-1/2 overflow-x-hidden">
                            <CardBody className='p-0'>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                                    TERRENO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <Card className='w-full border-0' shadow={false}>
                                                <CardBody className='p-0'>
                                                    <table className="w-full min-w-[640px] table-auto border">
                                                        <thead>
                                                        <tr className='bg-gray-50'>
                                                            {["Cve. Val.", "Descripción", "Área"].map(
                                                                (el) => (
                                                                    <th
                                                                        key={el}
                                                                        className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                    >
                                                                        <Typography
                                                                            variant="small"
                                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                        >
                                                                            {el}
                                                                        </Typography>
                                                                    </th>
                                                                )
                                                            )}
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {(!fusionedLands || fusionedLands.length === 0) ? (
                                                            <tr className="w-full">
                                                                <td colSpan="100%" className="text-center py-3">
                                                                    <strong>El predio no cuenta con terrenos
                                                                        registrados.</strong>
                                                                </td>
                                                            </tr>
                                                        ) : (Object.entries(fusionedLands).map(([landId, data], index, array) => {
                                                                const className = `py-3 px-5 ${
                                                                    index === array.length - 1 ? "" : "border-b border-blue-gray-50"
                                                                }`;
                                                                return (
                                                                    <tr key={landId}
                                                                        className="hover:bg-gray-50 cursor-pointer">
                                                                        <td className={className}>{data.rustic_land_value_id ? data.rustic_land_value_id : 'N/A'}</td>
                                                                        <td className={className}>{data.rustic_land_desc ? data.rustic_land_desc : 'Terreno urbano'}</td>
                                                                        <td className={className}>
                                                                            <NumericFormat
                                                                                value={data.area}
                                                                                displayType={'text'}
                                                                                allowLeadingZeros
                                                                                thousandSeparator=","
                                                                            /> {getUnit}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        )}
                                                        </tbody>
                                                        <tfoot>
                                                        <tr className='border-t'>
                                                            <td colSpan='2'
                                                                className='py-3 px-5 text-right border-r'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Totales
                                                                </Typography>
                                                            </td>
                                                            <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                                <NumericFormat
                                                                    value={resultLands.toFixed(2)}
                                                                    displayType={'text'}
                                                                    allowLeadingZeros
                                                                    thousandSeparator=","
                                                                /> {getUnit}
                                                            </td>
                                                        </tr>
                                                        </tfoot>
                                                    </table>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                                    CONSTRUCCIONES
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <Card className='w-full border-0' shadow={false}>
                                                <CardBody className='p-0'>
                                                    <table className="w-full min-w-[640px] table-auto">
                                                        <thead>
                                                        <tr className='bg-gray-50'>
                                                            {["Cve. Valuación", "Edad", "Sup. Construcción"].map(
                                                                (el) => (
                                                                    <th
                                                                        key={el}
                                                                        className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                    >
                                                                        <Typography
                                                                            variant="small"
                                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                        >
                                                                            {el}
                                                                        </Typography>
                                                                    </th>
                                                                )
                                                            )}
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {(!fusionedConstructions || fusionedConstructions.length === 0) ? (
                                                            <tr className="w-full">
                                                                <td colSpan="100%" className="text-center py-3">
                                                                    <strong>Los predios no cuentan con
                                                                        construcciones.</strong>
                                                                </td>
                                                            </tr>
                                                        ) : (fusionedConstructions.map((construction, index) => {
                                                                const className = `py-3 px-5 ${
                                                                    index === constructions.length - 1 ? "" : "border-b border-blue-gray-50"
                                                                }`;
                                                                return (
                                                                    <tr key={construction.construction_id}
                                                                        className="hover:bg-gray-50 cursor-pointer">
                                                                        <td className={className}>
                                                                            {construction.construction_value_id}
                                                                        </td>
                                                                        <td className={className}>
                                                                            {construction.construction_devaluation_id.toString()}
                                                                        </td>
                                                                        <td className={className}>
                                                                            {construction.area}
                                                                            <span
                                                                                className='py-2'>m<sup>2</sup></span>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        )}
                                                        </tbody>
                                                        <tfoot>
                                                        <tr className='border-t'>
                                                            <td colSpan='2'
                                                                className='py-3 px-5 text-right border-r'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Totales
                                                                </Typography>
                                                            </td>
                                                            <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                                <NumericFormat
                                                                    value={resultConstructions.toFixed(2)}
                                                                    displayType={'text'}
                                                                    thousandSeparator=","
                                                                /> m<sup>2</sup>
                                                            </td>
                                                        </tr>
                                                        </tfoot>
                                                    </table>
                                                    <div
                                                        className='flex flex-row gap-4 w-full mt-6 text-center border rounded-md bg-gray-50'>
                                                        <div
                                                            className='flex flex-col w-full p-4 place-content-center'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Instalaciones especiales
                                                            </Typography>
                                                            <div
                                                                className="flex flex-row justify-center gap-1"
                                                            >
                                                                <NumericFormat
                                                                    value={lot.special_facilities_value}
                                                                    displayType={'text'}
                                                                    prefix={'$'}
                                                                    thousandSeparator=","
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            className={`flex flex-col w-full p-4 ${lot.special_facilities && 'border rounded-md bg-gray-50'}`}>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Descripción de instalaciones especiales
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.special_facilities}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-300 text-sm mt-3 mb-6 font-bold uppercase">
                                    NOTAS DE MOVIMIENTOS DEL PREDIO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                            >
                                                Notas
                                            </Typography>
                                            <textarea
                                                type="text"
                                                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                value={lotNotes}
                                                onChange={(e) => setLotNotes(e.target.value)}
                                                rows="6"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                                <Button
                                    className="w-full bg-green-500 mt-4 hover:bg-green-600 text-white rounded-md px-5 py-3 font-semibold"
                                    onClick={() => handleSubmit()}
                                    disabled={loaderActive}
                                >
                                    GUARDAR
                                </Button>
                                {
                                    error && <p style={{color: "red"}}>{error}</p>
                                }
                            </CardBody>
                        </div>
                    </div>
                </div>
            )}
            <Dialog open={openEndDialog} handler={setOpenEndDialog}>
                <DialogHeader>Guardado</DialogHeader>
                <DialogBody>
                    <Typography>
                        Se actualizo el predio
                    </Typography>
                </DialogBody>
                <DialogFooter>
                    <Button
                        className="bg-green-500 text-white"
                        onClick={() => handleReset()}
                        disabled={loaderActive}
                    >
                        Finalizar
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    )
};

export default Fusion;
